import React, { Component } from 'react';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import "./RichTextCss.css";
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import draftToHtml from 'draftjs-to-html';

const EditorWrapper = styled.div`
  .public-DraftEditorPlaceholder-root {
    color: rgba(0, 0, 0, 0.4);
    position: absolute;
    pointer-events: none;
  }
`;

function convertToHtml(editorContent) {
  return draftToHtml(convertToRaw(editorContent));
}

function convertToPlainText(editorContent) {
  const blocks = convertToRaw(editorContent).blocks;
  const plainText = blocks.map(block => block.text).join('\n');
  return plainText;
}

export default class RichText extends Component {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
  };

  componentDidMount() {
    const { value } = this.props;

    if (value) {
      const blocksFromHtml = htmlToDraft(value);

      const { contentBlocks, entityMap } = blocksFromHtml;

      const contentState = ContentState.createFromBlockArray(
        contentBlocks,

        entityMap
      );

      const editorState = EditorState.createWithContent(contentState);

      this.setState({ editorState });
    }
  }

  // componentDidMount() {
  //   const { value } = this.props;
  //   if (value) {
  //     const contentState = ContentState.createFromText(value);
  //     const editorState = EditorState.createWithContent(contentState);
  //     this.setState({ editorState });
  //   }
  // }

  onEditorStateChange = (editorState) => {
    this.setState({ editorState });

    const { getContent, name } = this.props;
    const contentState = editorState.getCurrentContent();
    const plainText = convertToHtml(contentState);
    getContent(plainText, name);
  };

  render() {
    const { placeholder } = this.props;
    return (
      <div>
        <EditorWrapper>
          <Editor
            editorStyle={{
              minHeight: 154,
              padding: '8px',
              lineHeight: 'normal',
              resize: 'vertical',
              overflow: 'auto',
              fontSize: '16px',
            }}
            placeholder={placeholder}
            editorState={this.state.editorState}
            toolbarClassName="toolbar"
            wrapperClassName=""
            editorClassName="editor"
            toolbar={{
              options: ['inline', 'blockType', 'list', 'link'],

              inline: {
                options: ['bold', 'italic', 'underline'],
              },

              blockType: {
                inDropdown: false,
                options: [],

                // options: ['Normal', 'H1', 'H2', 'Blockquote'],
              },

              list: {
                options: ['unordered', 'ordered'],
              },

              link: {
                options: [],
              },

            }}
            onEditorStateChange={this.onEditorStateChange}
          />
        </EditorWrapper>
      </div>
    );
  }
}
